import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';

import { AppState } from '../app.reducer';
import { selectLoggedIn } from '../store/auth/auth.reducer';
import { loginSuccess, logout } from '../store/auth/auth.actions';
import { AuthenticationAdapter } from '../adapters/authentication.adapter';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private authAdapter: AuthenticationAdapter
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(selectLoggedIn).pipe(
      take(1),
      map((loggedIn) => {
        if (
          state.url.startsWith('/auth/login') &&
          next.queryParams['jwt'] &&
          next.queryParams['user'] &&
          next.queryParams['refreshToken']
        ) {
          if (loggedIn) {
            this.store.dispatch(logout());
            setTimeout(() => this.setCookiesFromParameters(next.queryParams), 500);
            return false;
          }
          this.setCookiesFromParameters(next.queryParams);
          return false;
        }
        if (loggedIn && state.url.startsWith('/auth')) {
          return this.router.createUrlTree(['/dashboard'], { queryParams: next.queryParams });
        }
        if (!loggedIn && !state.url.startsWith('/auth')) {
          this.store.dispatch(logout());
          return false;
        }
        return true;
      })
    );
  }

  private async setCookiesFromParameters(params: Params) {
    const token = params['refreshToken'];
    this.authAdapter
      .getCookieForToken(token)
      .subscribe(() => this.store.dispatch(loginSuccess({ token: params['jwt'], user: JSON.parse(params['user']) })));
  }
}
